module.exports = __webpack_public_path__ + "media/img/welurowa-c382862e.png";